import type {CaseNotebook} from '../../domain/models';
import {DeadlineTool} from '../DeadlineTool';
import {ModalFrame} from './Sheets';
export function DeadlineSheet({notebook,close,save}:{notebook:CaseNotebook;close:()=>void;save:(input:{knownOn:string;reportedOn:string},deadline:string)=>Promise<void>}){
 const first=notebook.receipts.find(row=>row.relation==='first_report')??notebook.receipts[0];const initial=notebook.deadline??{knownOn:first?.checkedAt.slice(0,10)??'',reportedOn:first?.publishedAt?.slice(0,10)??''};
 return <ModalFrame title="청구 기한 준비" close={close}><DeadlineTool initial={initial} save={save}/><button className="button secondary" onClick={close}>닫기</button></ModalFrame>;
}
